<template>
    <img 
        :data-src="lazySrc" 
        :data-srcset="lazySrcset" 
        :style="style" 
        class="img-container" 
    />
</template>

<script>
import lozad from "lozad";
export default {
    name: 'ImgContainer',
    /**
     * входные данные компонента
     * @property {string} backgroundColor - цвет фона
     * @property {number} height - высота
     * @property {number} width - ширина
     * @property {string} lazySrc - путь до картинки
     * @property {string} lazySrcset - путь до картинки
     */
    props: {
        backgroundColor: { 
            type: String, 
            default: 'transparent' 
        },
        height: { 
            type: Number, 
            default: 0 
        },
        width: { 
            type: Number, 
            default: 0 
        },
        lazySrc: {
            type: String,
            default: ''
        },
        lazySrcset: {
            type: String,
            default: ''
        }
    },
    /**
     * данные компонента
     * @property {boolean} loading - условие загрузки
     */
    data: () => ({
        loading: true
    }),
    computed: {
        /**
         * соотношения сторон
         * @returns {number}
         */
        aspectRatio() {
            return (this.width === 0 || this.height === 0) ? 0 : (this.height / this.width) * 100;
        },
        /**
         * стиль
         * @returns {object}
         */
        style() {
            let style = {
                backgroundColor: this.backgroundColor,
                width: this.width === 0 ? 'auto' : `${this.width}px`,
                height: (this.loading && this.aspectRatio) ? 0 : 'auto',
                paddingTop: (this.loading && this.aspectRatio) ? `${this.aspectRatio}%` : 0,
            }
            return style;
        }
    },
    mounted() {
        // слушаем событие загрузки
        this.$el.addEventListener("load", this.setLoadingState);
        let observer = lozad(this.$el);
        observer.observe();
    },
    destroyed() {
        // отвязываем прослушивание события загрузки
        this.$el.removeEventListener("load", this.setLoadingState);
    },
    methods: {
        /**
         * переключить состояние
         */
        setLoadingState() {
            this.loading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .img-container {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
    }
</style>